import React, { useState } from 'react'
import TextButtonDocFinalProduct from './helpers/TextButtonDocFinalProduct'
// import TextButtonMediaFinalProduct from './helpers/TextButtonMediaFinalProduct'
import ViewVideoOrImgs from './helpers/ViewVideoOrImgs'

const DetailsFinalProduct = ({
  item,
  onClickViewDocs,
  idPresentation,
  isEditProductPresentation,
  onlyViewDocsProduct,
}) => {
  const [isButtonViewImg, setIsSetButtonViewImg] = useState(true)

  return (
    <div className='product-detail__container' style={{ display: 'inline-flex', width: '100%', marginTop: '-30px' }}>
      <div style={{ width: '75%' }}>
        <ViewVideoOrImgs itemSelected={item} buttonViewImg={isButtonViewImg} />
      </div>
      <div style={{ width: '25%' }}>
        <div>
          <h4 className='product-detail__title-product'>{item.nombre}</h4>
          <h5 className='product-detail__subtitle-product'>Descripción</h5>
          <p className='product-detail__text'> {item.descripcion} </p>
        </div>
        <div className='product-detail__button-container'>
          <div className='product-detail__tabs-container'>
            <button
              className={`product-detail__tab ${
                isButtonViewImg ? 'product-detail__tab--active' : ''
              }`}
              onClick={() => setIsSetButtonViewImg(true)}
              type='button'
            >
              <span className='tab-text'>Imágenes</span>
            </button>
            <div className='product-detail__tab-separator'></div>
            <button
              onClick={() => setIsSetButtonViewImg(false)}
              className={`product-detail__tab ${
                !isButtonViewImg ? 'product-detail__tab--active' : ''
              }`}
              type='button'
            >
              <span className='tab-text'>Video</span>
            </button>
            <div className='product-detail__tab-separator'></div>
            <TextButtonDocFinalProduct
              idPresentation={idPresentation}
              itemSelected={item}
              onClickViewDocs={onClickViewDocs}
              isEditProductPresentation={isEditProductPresentation}
              onlyViewDocsProduct={onlyViewDocsProduct}
            />
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className='product-detail__container' style={{ marginTop: '-30px' }}>
      <ViewVideoOrImgs itemSelected={item} buttonViewImg={isButtonViewImg} />
      <div>
        <div>
          <h4 className='product-detail__title-product'>{item.nombre}</h4>
          <h5 className='product-detail__subtitle-product'>Descripción</h5>
          <p className='product-detail__text'> {item.descripcion} </p>
        </div>
        <div className='product-detail__button-container'>
          <div className='product-detail__tabs-container'>
            {/* Tab para Imágenes */}
            <button
              className={`product-detail__tab ${
                isButtonViewImg ? 'product-detail__tab--active' : ''
              }`}
              onClick={() => setIsSetButtonViewImg(true)}
              type='button'
            >
              <span className='tab-text'>Imágenes</span>
            </button>
            <div className='product-detail__tab-separator'></div>

            {/* Tab para Video */}
            <button
              onClick={() => setIsSetButtonViewImg(false)}
              className={`product-detail__tab ${
                !isButtonViewImg ? 'product-detail__tab--active' : ''
              }`}
              type='button'
            >
              <span className='tab-text'>Video</span>
            </button>

            {/* Separador */}
            <div className='product-detail__tab-separator'></div>

            {/* Tab para Documentos */}
            <TextButtonDocFinalProduct
              idPresentation={idPresentation}
              itemSelected={item}
              onClickViewDocs={onClickViewDocs}
              isEditProductPresentation={isEditProductPresentation}
              onlyViewDocsProduct={onlyViewDocsProduct}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default DetailsFinalProduct
